import {
  beRecipientGetGroupDetails,
  beRecipientGetListOfGroupDetails,
} from 'Api/beRecipientApi'

import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import { INPUT_MESSAGES_MAX_ITEMS } from 'Constants'

export const fetchGroups = async (
  searchTerm: string,
): Promise<{
  items: Array<{ label: string; value: number }>
  totalItems: number
}> => {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const { Items, TotalItems } = await beRecipientGetListOfGroupDetails(idList, {
    searchType: 'CONTAINS',
    searchBy: searchTerm,
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: INPUT_MESSAGES_MAX_ITEMS,
  })

  return {
    items: Items.map(({ Id, Name }: { Id: number; Name: string }) => ({
      value: Id,
      label: `${Id} - ${Name}`,
    })),
    totalItems: TotalItems,
  }
}

export const fetchGroupById = async (
  id: number,
): Promise<{ label: string; value: number } | undefined> => {
  const res: { Id: number; Name: string } | null | undefined =
    await beRecipientGetGroupDetails(id)

  if (res !== null && res !== undefined) {
    return {
      value: res.Id,
      label: `${res.Id} - ${res.Name}`,
    }
  }

  return undefined
}
